// First-paint metadata for Journal articles that own a first-class route.
// Base44 injects one crawler <title> per component, so BlogArticlePage would ship a
// generic title for all 21 routes. This registry lets the page set the correct
// title/description/H1 synchronously, before the article record resolves.
// Values mirror each published BlogArticle record (meta_title / meta_description / title).

export const ARTICLE_META = {
  'ti-kourema-mou-tairiazei': {
    title: 'Τι κούρεμα μου ταιριάζει; Οδηγός επιλογής | Ikonomakis',
    description: 'Ανακάλυψε ποιο κούρεμα σου ταιριάζει βάσει σχήματος προσώπου, υφής μαλλιών και lifestyle. Πρακτικός οδηγός από τον Θοδωρή Οικονομάκη.',
    h1: 'Τι κούρεμα μου ταιριάζει;',
  },
  'ti-kourema-tairiazei-sto-prosopo-mou': {
    title: 'Κούρεμα ανά σχήμα προσώπου: πλήρης οδηγός | Ikonomakis',
    description: 'Οβάλ, στρογγυλό, τετράγωνο, καρδιά, τρίγωνο — μάθε ποιο κούρεμα κολακεύει κάθε σχήμα προσώπου. Πρακτικός οδηγός.',
    h1: 'Τι κούρεμα ταιριάζει στο πρόσωπό μου;',
  },
  'pos-na-epilexeis-sosto-kourema': {
    title: 'Πώς να επιλέξεις το σωστό κούρεμα | Οδηγός Ikonomakis',
    description: 'Βήμα προς βήμα οδηγός για να επιλέξεις κούρεμα που σε κολακεύει: σχήμα προσώπου, υφή, lifestyle και consultation.',
    h1: 'Πώς να επιλέξεις το σωστό κούρεμα',
  },
  'ti-einai-to-balayage': {
    title: 'Τι είναι το Balayage; Πλήρης οδηγός | Ikonomakis',
    description: 'Τι είναι το balayage, πώς γίνεται, πόσο κρατά και σε ποιους ταιριάζει. Πλήρης οδηγός από τον Θοδωρή Οικονομάκη.',
    h1: 'Τι είναι το balayage;',
  },
  'balayage-vs-highlights': {
    title: 'Balayage vs Highlights: πλήρης σύγκριση | Ikonomakis',
    description: 'Balayage ή highlights; Μάθε ποια τεχνική χρώματος ταιριάζει στα μαλλιά σου, πόσο κρατά και τι κοστίζει.',
    h1: 'Balayage vs Highlights: ποια η διαφορά;',
  },
  'ti-einai-to-hair-glossing': {
    title: 'Τι είναι το Hair Glossing; Οδηγός | Ikonomakis',
    description: 'Hair glossing: τι είναι, πώς λειτουργεί, σε ποιους ταιριάζει και πόσο κρατά. Εξήγηση από τον Θοδωρή Οικονομάκη.',
    h1: 'Τι είναι το hair glossing;',
  },
  'pote-chreiazetai-color-correction': {
    title: 'Color Correction: Πότε Χρειάζεται; | Ikonomakis',
    description: 'Color correction: τι είναι, πότε χρειάζεται, πόσο κοστίζει και πόσες συνεδρίες απαιτεί. Εξήγηση από expert colorist.',
    h1: 'Πότε χρειάζεται color correction;',
  },
  'poso-kostizei-premium-kourema': {
    title: 'Τιμές Premium Κουρέματος Αθήνα | Ikonomakis Hair Atelier',
    description: 'Πόσο κοστίζει ένα premium κούρεμα στην Αθήνα; Τι περιλαμβάνει η τιμή, τι διαφορά κάνει ο colorist tier και γιατί αξίζει.',
    h1: 'Πόσο κοστίζει ένα premium κούρεμα;',
  },
  'hair-transformation-guide': {
    title: 'Hair Transformation Οδηγός | Ikonomakis Hair Atelier',
    description: 'Ολοκληρωμένος οδηγός για hair transformation: πώς να σχεδιάσεις την αλλαγή σου, τι να περιμένεις και πώς να τη διατηρήσεις.',
    h1: 'Hair Transformation: ολοκληρωμένος οδηγός',
  },
  'ai-hair-analysis-greece': {
    title: 'AI Hair Analysis Ελλάδα | Face Metrics Pro Ikonomakis',
    description: 'Το Face Metrics Pro είναι η πρώτη AI ανάλυση σχήματος προσώπου για κούρεμα και χρώμα στην Ελλάδα. Μάθε πώς λειτουργεί.',
    h1: 'AI Hair Analysis στην Ελλάδα',
  },
  'poso-kostizei-balayage-2026': {
    title: 'Τιμές Balayage 2026 — Πόσο Κοστίζει; | Ikonomakis Χαλάνδρι',
    description: 'Αναλυτικός οδηγός τιμών balayage 2026: τι επηρεάζει το κόστος, διαφορά tier ειδικού, τεχνικές και τιμές από €150.',
    h1: 'Πόσο κοστίζει το balayage το 2026; Αναλυτικός οδηγός τιμών',
  },
  'balayage-i-airtouch': {
    title: 'Balayage ή Airtouch; Πώς να Επιλέξεις | Ikonomakis Χαλάνδρι',
    description: 'Balayage vs Airtouch — ποια τεχνική ταιριάζει στον τύπο μαλλιών σου, ποια κρατά περισσότερο και ποια είναι η διαφορά στο αποτέλεσμα.',
    h1: 'Balayage ή Airtouch; Πώς να διαλέξεις τη σωστή τεχνική για τα μαλλιά σου',
  },
  'ai-analysi-prosopou-kourema-xroma': {
    title: 'AI Ανάλυση Προσώπου: Κούρεμα & Χρώμα | Ikonomakis',
    description: 'Το Face Metrics Pro αναλύει επιστημονικά τη γεωμετρία προσώπου για να βρει το ιδανικό κούρεμα και χρώμα. Πώς λειτουργεί, τι περιλαμβάνει και πόσο κοστίζει.',
    h1: 'Πώς η AI ανάλυση προσώπου βρίσκει το χρώμα και το κούρεμα που σου ταιριάζει',
  },
  'poso-sychna-syntiritisi-xantho': {
    title: 'Συντήρηση Ξανθών Μαλλιών 2026 — Πόσο Συχνά; | Ikonomakis',
    description: 'Πόσο συχνά χρειάζεσαι ραντεβού για συντήρηση ξανθών μαλλιών; Οδηγός από blonde specialist: τύποι ξανθού, χρονοδιάγραμμα, προϊόντα και κόστος.',
    h1: 'Πόσο συχνά χρειάζεται συντήρηση το ξανθό; Οδηγός από blonde specialist',
  },
  'balayage-paranoiseis': {
    title: 'Οι 5 Παρανοήσεις για το Balayage | Ikonomakis Hair Atelier',
    description: 'Τι είναι πραγματικά το balayage, πώς διαφέρει από highlights και τι να περιμένεις στην πρώτη σου επίσκεψη.',
    h1: 'Οι 5 Παρανοήσεις για το Balayage — και η Αλήθεια Πίσω από Κάθε Μία',
  },
  'pos-na-diatirisis-to-xroma-sou': {
    title: 'Συντήρηση Χρώματος Μαλλιών μετά τη Βαφή | Ikonomakis',
    description: 'Maintenance plan για κάθε χρωματική υπηρεσία. Shampoo, styling, θεραπείες και επαγγελματικές συμβουλές από το Ikonomakis Hair Atelier Χαλάνδρι.',
    h1: 'Πώς να Διατηρήσεις το Χρώμα σου Μετά τη Βαφή — Ο Πλήρης Οδηγός',
  },
  'neo-epochi-premium-hairdressing-athina': {
    title: 'Premium Hairdressing στην Αθήνα | Ikonomakis',
    description: 'Πώς το Ikonomakis Hair Atelier συνδυάζει 30 χρόνια εμπειρίας με AI-driven τεχνολογία Face Metrics Pro και bespoke χρώμα στη Βόρεια Αθήνα.',
    h1: 'Η Νέα Εποχή του Premium Hairdressing στην Αθήνα',
  },
  'pos-i-texniti-noimosini-vrisket-to-kourema': {
    title: 'AI και Κούρεμα ανά Σχήμα Προσώπου | Face Metrics Pro',
    description: 'Πώς η τεχνητή νοημοσύνη και η μορφολογική ανάλυση προσώπου (Face Metrics Pro) βρίσκουν το ιδανικό κούρεμα — επιστήμη, διαδικασία και αποτελέσματα.',
    h1: 'Πώς η τεχνητή νοημοσύνη βρίσκει το κούρεμα που ταιριάζει στο πρόσωπό σου',
  },
  'prosopologia-kai-mallia-face-metrics-pro': {
    title: 'Προσωπολογία & Προσωπομετρία στα Μαλλιά | Ikonomakis',
    description: 'Προσωπολογία (visagisme) και προσωπομετρία: πώς η ανάγνωση της προσωπικότητας και οι μετρήσεις του Face Metrics Pro AI σχεδιάζουν το κούρεμά σας.',
    h1: 'Προσωπολογία και προσωπομετρία: η εικόνα που σας εκφράζει, με ακρίβεια',
  },
  'ai-hair-analysis-changing-consultations': {
    title: 'AI Hair Analysis & Salon Consultations | Ikonomakis',
    description: 'How Face Metrics Pro supports personalised haircut and colour consultations at Ikonomakis Hair Atelier in Chalandri, Athens. What the analysis includes.',
    h1: 'AI Hair Analysis: How Technology Is Changing Salon Consultations',
  },
  'what-is-face-metrics-pro-greece': {
    title: 'What Is Face Metrics Pro? AI Hair Analysis | Ikonomakis',
    description: 'Face Metrics Pro in Chalandri, Athens: facial analysis for personalised haircut and colour recommendations. Atelier consultation: €100 for 45 minutes.',
    h1: "What Is Face Metrics Pro? Inside Greece's First AI-Powered Salon Experience",
  },
};

export const getArticleMeta = (slug) => ARTICLE_META[slug] || null;